import { createTranslations } from '@npco/common-utils-translations'

export const accountStatementListTranslations = createTranslations({
  fileName: '{date} Account Statement',
  downloadSuccess: 'Your statement has been downloaded.',
  downloadFailure: 'Download failed. Please refresh and try again.',
})
